import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from './scrollToTop';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);
}; 